<template>
    <portal to="modals" v-if="show" @keyup.esc="close">
        <div class="modal-backdrop z-50">
            <div class="modal" :class="classes" v-click-outside.modal="close">
                <div
                    v-if="closeIcon.length >= 1"
                    class="modal-close modal-close__custom"
                    @click="close"
                >
                    {{ closeIcon }}
                </div>
                <div v-else class="modal-close" @click="close">×</div>

                <!-- Left here for backwards compatibility -->
                <slot name="close"></slot>

                <slot v-bind="{ close: close, payload: payload }"></slot>
            </div>
        </div>
    </portal>
</template>

<script>
export default {
    props: {
        name: {
            required: false,
            type: String,
        },

        closeIcon: {
            required: false,
            default: '×',
            type: String,
        },

        preventBackgroundScrolling: {
            default: true,
            type: Boolean,
        },

        classes: {
            default: '',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            show: false,
            payload: null,
        };
    },

    watch: {
        show: {
            immediate: true,
            handler: function(show) {
                if (show) {
                    this.preventBackgroundScrolling &&
                        document.body.style.setProperty('overflow', 'hidden');
                } else {
                    this.preventBackgroundScrolling &&
                        document.body.style.removeProperty('overflow');
                }
            },
        },
    },

    methods: {
        close() {
            this.show = false;
        },
    },

    created() {
        this.$modal.on(`open:${this.name}`, payload => {
            this.payload = payload;
            this.show = true;
        });

        const escapeHandler = e => {
            if (e.key === 'Escape' && this.show) {
                this.close();
            }
        };

        document.addEventListener('keydown', escapeHandler);

        this.$once('hook:destroyed', () => {
            document.removeEventListener('keydown', escapeHandler);
        });
    },
};
</script>
